import { Inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { SaleSendDocumentsToKsefCommand, SaleSendDocumentsToKsefCommandHandlerBase, SaleSendDocumentsToKsefResponse } from '@skylab-shared/business';
import { HttpService } from '@skylab-shared/core';

@CommandHandlerFor(SaleSendDocumentsToKsefCommand)
@Injectable({ providedIn: 'root' })
export class SaleSendDocumentsToKsefCommandHandler {
    private commandHandler: SaleSendDocumentsToKsefCommandHandlerBase;

    public constructor(
        @Inject(Http) http: HttpService
    ) {
        this.commandHandler = new SaleSendDocumentsToKsefCommandHandlerBase(http);
    }

    public async handleAsync(params: SaleSendDocumentsToKsefCommand): Promise<SaleSendDocumentsToKsefResponse> {
        return await this.commandHandler.handleAsync(params);
    }
}
